/**
 * Pure helpers for resolving themeId during screen creation.
 * Extracted for testability — no React/tRPC/Next.js dependencies.
 */

/**
 * Resolve the themeId for a new screen created from the sidebar (centered).
 * Priority: explicit option > active screen's theme > flow's latest theme.
 */
export function resolveThemeForCenteredScreen(
  optionsThemeId: string | undefined,
  activeScreenId: string | null | undefined,
  existingScreens: {id: string; themeId: string | null}[],
  flowThemeId: string | null,
): string | undefined {
  if (optionsThemeId) return optionsThemeId;
  if (activeScreenId) {
    const activeScreen = existingScreens.find((s) => s.id === activeScreenId);
    if (activeScreen?.themeId) return activeScreen.themeId;
  }
  return flowThemeId ?? undefined;
}

/**
 * Resolve the themeId for a new screen created relative to another screen.
 * Priority: source structure's theme > source screen's theme.
 */
export function resolveThemeForRelativeScreen(
  sourceStructureThemeId: string | null | undefined,
  sourceScreenThemeId: string | null | undefined,
): string | undefined {
  return sourceStructureThemeId ?? sourceScreenThemeId ?? undefined;
}
